import styled from '@emotion/styled'
import { Item } from 'app/components/Common/Accordion/Item'
import React, { memo } from 'react'
import { Accordion } from 'react-accessible-accordion'

export interface Props {
  description?: string
  index?: string
  isExpanded?: string
  title: string
}

export const Accordions = memo(function Accordions({
  description,
  isExpanded,
  index,
  title,
}: Props) {
  if (!description) {
    return null
  }

  return (
    <Container
      allowZeroExpanded
      className={index === '0' ? 'is-first' : undefined}
      preExpanded={
        typeof window !== 'undefined' && window.innerWidth > 1199
          ? [isExpanded || '0']
          : ['']
      }
    >
      <Item
        className={isExpanded ? 'expanded' : undefined}
        description={description}
        title={title}
        uuid={index}
      />
    </Container>
  )
})

const Container = styled(Accordion)`
  width: 100%;
  border: 0;
  border-radius: 0;

  > div {
    background: ${({ theme }) => theme.colors.variants.neutralLight4};
    margin-top: 0.375rem;
    &.active {
      svg {
        opacity: 1;
        transform: rotate(90deg);
      }
    }
  }
`
